import type { FilterSpecification } from 'maplibre-gl';

export type MapLegendItem = {
	legendItemId: string;
	filterValue?: string;
	label: string;
	color?: string;
	image?: string;
	enabled: boolean;
};

export type MapLayer = {
	layerId: string;
	systemId: string;
	initialFilter?: FilterSpecification | undefined;
	filterAttr: string;
	legendItems: MapLegendItem[];
	minzoom?: number;
	layerAllEnabled: boolean;
	layerAnyEnabled: boolean;
	// Skips the global mapDataFilter for layers whose schema lacks its attributes (e.g. uploaded crashes).
	excludeFromMapDataFilter?: boolean;
};

function createLegendStore() {
	let layers = $state<MapLayer[]>([]);

	return {
		get layers() {
			return layers;
		},

		setMapLayers(value: MapLayer[]) {
			layers = value;
		},

		// Called on app switch so the next mount re-parses rather than reusing the previous app's layers.
		clear() {
			layers = [];
		},

		/** Toggle a single legend item, then recompute layerAllEnabled / layerAnyEnabled. */
		setLegendLayerVisibility({
			layerId,
			legendItemId,
			enabled
		}: {
			layerId: string;
			legendItemId: string;
			enabled: boolean;
		}) {
			const layer = layers.find((l) => l.layerId === layerId);
			if (!layer) return;
			for (const item of layer.legendItems) {
				if (item.legendItemId === legendItemId) {
					item.enabled = enabled;
				}
			}
			layer.layerAllEnabled = layer.legendItems.every((item) => item.enabled);
			layer.layerAnyEnabled = layer.legendItems.some((item) => item.enabled);
		},

		/** Toggle all legend items in a layer at once. */
		setAllLegendLayerVisibility({ layerId, enabled }: { layerId: string; enabled: boolean }) {
			const layer = layers.find((l) => l.layerId === layerId);
			if (!layer) return;
			for (const item of layer.legendItems) {
				item.enabled = enabled;
			}
			layer.layerAllEnabled = enabled;
			layer.layerAnyEnabled = enabled;
		}
	};
}

export const legendStore = createLegendStore();
